import { Link } from "react-router-dom";
import Card from "./Card";
import { formatCompact } from "../utils/format";

export interface RankedItem {
  rank: number;
  name: string;
  subtitle?: string;
  tokens: number;
}

interface ActivityTopListProps {
  title: React.ReactNode;
  linkLabel: string;
  linkTo: string;
  items?: RankedItem[];
  loading?: boolean;
}

export default function ActivityTopList({
  title,
  linkLabel,
  linkTo,
  items = [],
  loading,
}: ActivityTopListProps) {
  return (
    <Card padding="lg" className="flex flex-col h-full">
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-h3 text-text-main font-bold">{title}</h3>
        <Link to={linkTo} className="text-small text-primary hover:underline shrink-0">
          {linkLabel}
        </Link>
      </div>
      {loading ? (
        <div className="space-y-3 mt-3">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="h-10 bg-surface-hover rounded animate-pulse" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <p className="text-body text-text-tertiary py-8 text-center">داده‌ای وجود ندارد</p>
      ) : (
        <div className="divide-y divide-line mt-1">
          {items.map((item) => (
            <div key={item.rank} className="flex items-center justify-between gap-4 py-2.5">
              <div className="flex items-center gap-3 min-w-0">
                <span className="w-6 h-6 shrink-0 flex items-center justify-center rounded-full text-[11px] font-medium text-text-tertiary border border-line">
                  {item.rank.toLocaleString("fa-IR")}
                </span>
                <div className="min-w-0">
                  <p className="text-body font-semibold text-text-main truncate">{item.name}</p>
                  {item.subtitle ? (
                    <p className="text-small text-text-tertiary mt-0.5 truncate" dir="ltr">
                      {item.subtitle}
                    </p>
                  ) : null}
                </div>
              </div>
              <span className="text-body font-medium text-text-secondary shrink-0">
                <span dir="ltr">{formatCompact(item.tokens)}</span>{" "}
                <span className="text-text-tertiary text-small">توکن</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
